module.exports = __webpack_public_path__ + "img/ic-voiture.175ceff0.svg";